module.exports = __webpack_public_path__ + "static/media/nsa.11a68e0d.svg";